<template>
    <div class="">
        <b-modal :model-value="modalAdActivos" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} {{ numContrato }} 
            </div>
            <div class="">
                <b-row class="text-center" v-if="listActivos?.length > 0"> 
                    <b-col cols="12">
                        <select multiple class="form-control" :items="activosSelected">
                            <option v-for="activosSel in listActivos" :key="activosSel?.id" :value="activosSel?.activo">{{ activosSel?.descripcion }}</option> 
                        </select>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center" v-else>
                    <h6>{{ labels.noData }}</h6> 
                </b-row>
                <div class="mt-1">
                    <b-col cols="3">
                        <b-button class="md-primary" @click="aceptaActivos">{{ labels.save }}</b-button> 
                    </b-col>
                    <b-col cols="2">
                        <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                    </b-col>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato' 
import Activos from '../../services/Activos' 
export default {
    name : 'AdicionarActivos',
    props:['modalAdActivos','numContrato'],
    components:{
    },
    data : () => ({
	activosSelected : [],
	listActivos : [],
	listContrato : [],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Adición de activos al contrato Nro.', 
                    save : 'Guardar',
                    close : 'Cerrar',
                    detalle : 'Modificación Detalle',
                    activos : 'Modificación Activos',
                    cuotas : 'Cuotas',
                    noData : 'No hay activos disponibles.', 
                }
            }else{
                return {
                    title : 'Addition of assets to contract No.', 
                    save : 'Save',
                    close : 'Close',
                    detalle : 'Detail',
                    activos : 'Assets',
                    cuotas : 'Cuotas',
                    noData : 'No assets available.', 
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        aceptaActivos(){

            const info = {
                'lstAct' : this.activosSelected, 
                'numContrato' : this.numContrato, 
                'idUser' : this.$store.state.userId 
            }
            Activos.addNewActivoAlContrato(info) 
            .then((res) => { 
                if (res.status == 200) { 
                    this.$toast.success(res.data.message); 
                    this.$router.push('modificarcontrato'); 
                    // this.modalAdActivos = false 
                    location.reload(); 
                }
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message); 
                }
            })
        }
    },
mounted(){
 Contrato.leaContrato(this.numContrato) 
 .then((res) => { 
  this.listContrato = res.data.contrato 
 }). 
	then(() => {
  Activos.leaActivosColocar(this.listContrato[0].identificacion, 
   this.listContrato[0].tipo_activo) 
  .then((res) => { 
   this.listActivos = res.data.listActivos 
		})
	})
 .catch((err) => console.log(err)) 
}

}
</script>
<style lang="css">
  .b-table-cell-container { 
    padding: 15px !important;
  }
  .b-table-head-label { 
    padding-left: 30px !important;
  }
</style>
